// Capa de acceso a datos para la feature de Interoperabilidad.

import { api } from '../../../api/client';

const BASE = '/interop';


/** Historial de peticiones de integración. */
const search = (searchData) => api.post(`${BASE}/history/log/search`,searchData);


export const interoperabilityHistoryApi = {

   search,
  
};
